import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { mergeStyleSets, Spinner } from '@fluentui/react';
import propTypes from 'prop-types';
import classNames from 'classnames';
const styles = mergeStyleSets({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '50vh'
    }
});
const LoadingSpinner = (_, context)=>/*#__PURE__*/ _jsx("div", {
        className: classNames([
            'loading',
            styles.container
        ]),
        children: /*#__PURE__*/ _jsx(Spinner, {
            label: context.loc('Gallery_Loading', 'Loading...'),
            ariaLive: "assertive",
            labelPosition: "left"
        })
    });
LoadingSpinner.contextTypes = {
    loc: propTypes.func
};
export default LoadingSpinner;
